import { useAuthenticationStore } from "@/store";
import { Navigate, Outlet } from "react-router-dom";

export const GuestRoute = () => {
	const accessToken = useAuthenticationStore((state) => state.accessToken);
	if (!accessToken) return <Outlet />;
	return <Navigate to="/" replace />;
};
